import React, { Fragment, useEffect, useState } from "react";
import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    FormGroup,
    Label,
} from "reactstrap";

import { useHistory } from "react-router-dom";
import AsyncSelect from "react-select/async";
import moment from "moment";

import Breadcrumb from "../../../../layout/breadcrumb";
import BootstrapTable from "../../../../share-components/table/BootstrapTable";
import { mapSearchAutoSuggestion } from "../../../../utils/mapper";
import { useDispatch, useSelector } from "react-redux";
import withReducer from "../../../../store/withReducer";
import sellerReducer from "../../store";
import { sellerAutoSuggestionApi } from "../../../../services/manage-product/productService";
import MonthPicker from "../../../../share-components/ui/MonthPicker";

import {
    downloadAdminCommissionExcel,
    downloadAdminCommissionPdf,
    EmailAdminCommissionExport,
    getSellerSettings,
    setSettings
} from "../../store/sellerSlice";

import { getCommissions, resendXeroCommission } from "../../store/sellerCommissionSlice";

import {
    formatterCurrency
} from "../../../../utils/common";

const SellerCommission = (props) => {
    let history = useHistory();
    const dispatch = useDispatch();

    const todayDate = new Date();
    
    // helper to ensure a value is a valid date/moment/string parseable by moment
    const isValidDate = (d) => d !== null && d !== undefined && moment(d).isValid();

    const [month, setMonth] = useState(
        todayDate.getDate() > 28
            ? new Date(todayDate.getFullYear(), todayDate.getMonth(), 1)
            : new Date(todayDate.getFullYear(), todayDate.getMonth() - 1, 1)
    );

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const authData = useSelector(({ authReducer }) => authReducer);
    const [seller, setSeller] = useState(authData.defaultSeller);
    const sellerCommission = useSelector(({ seller }) => seller.sellerCommission);

    const [loading, setLoading] = useState(false);
    const [resendingBatchId, setResendingBatchId] = useState(null);

    const dataMenu = [
        {
            type: 0,
            text: "Seller Commission"
        }
    ];

    const disabledMonth = (date) => {
        const now = new Date();
        // now.setMonth(now.getMonth() - 1);
        return date.getFullYear() > now.getFullYear() ||
               (date.getFullYear() === now.getFullYear() && date.getMonth() > now.getMonth());
    };

    const tableColumns = [
        {
            name: 'Seller Name',
            selector: row => row.name,
            sortable: false,
            left: true,
            width: '15%',
        },
        {
            name: 'Month',
            selector: row => row.end_date ? moment(row.end_date).format('YYYY-MMM') : '-',
            sortable: false,
            left: true,
        },
        {
            name: 'Total Amount (inc Vat) (£)',
            selector: row => formatterCurrency(row.total_net_amount || 0),
            sortable: false,
            right: true,
        },
        {
            name: 'Total Vat (£)',
            selector: row => formatterCurrency(row.total_vat_amount || 0),
            sortable: false,
            right: true,
        },
        {
            name: 'Total Amount (exc Vat) (£)',
            selector: row => formatterCurrency(row.total_net_amount_exc_vat || 0),
            sortable: false,
            right: true,
        },
        {
            name: 'Commission (inc Vat) (£)',
            selector: row => formatterCurrency(row.total_commission_amount_inc_vat || 0),
            sortable: false,
            right: true,
        },
        {
            name: 'Commission VAT (£)',
            selector: row => formatterCurrency(row.total_commission_vat_amount || 0),
            sortable: false,
            right: true,
        },
        {
            name: 'Commission (exc Vat) (£)',
            selector: row => formatterCurrency(row.total_commission_amount_exc_vat || 0),
            sortable: false,
            right: true,
        },
        {
            name: 'Agent Commission (£)',
            selector: row => formatterCurrency(row.agent_commission || 0),
            sortable: false,
            right: true,
        },
        {
            name: 'Action',
            selector: row => (
                <div>
                    {row.is_created_xero && <>
                        <a className={(loading ? "disabled" : "") + " cursor-pointer"} onClick={() => onAdminDownloadPDF(row)}>
                            <i className="fa fa-file-pdf-o" style={{ fontSize: 16, color: 'rgb(226,203,47)' }}></i>
                        </a>
                        <a className={(loading ? "disabled" : "") + " cursor-pointer ml-3"} onClick={() => onAdminEmail(row)}>
                            <i className="fa fa-envelope-o" style={{ fontSize: 16, color: 'rgb(226,68,47)' }}></i>
                        </a>
                        {resendingBatchId === row.batch_id ? (
                            <a className="cursor-pointer ml-3">
                                <i className="fa fa-spinner fa-spin" style={{ fontSize: 16, color: 'rgb(0,123,255)' }}></i>
                            </a>
                        ) : (
                            <a className="cursor-pointer ml-3" title="Resend to Xero" onClick={() => onResendXero(row)}>
                                <i className="fa fa-refresh" style={{ fontSize: 16, color: 'rgb(0,123,255)' }}></i>
                            </a>
                        )}
                    </>}
                    <a className={(loading ? "disabled" : "") + " cursor-pointer ml-3"} onClick={() => onAdminDownloadExcel(row)}>
                        <i className="fa fa-file-excel-o" style={{ fontSize: 16, color: 'rgb(40, 167, 69)' }}></i>
                    </a>
                    <a className={(loading ? "disabled" : "") + " cursor-pointer ml-3"} onClick={() => onAdminCommissionView(row)}>
                        <i className="fa fa-eye" style={{ fontSize: 16, color: 'rgb(112,71,64)' }}></i>
                    </a>
                </div>
            ),
            sortable: false,
            right: true,
            wrap: true,
        }
    ];

    useEffect(() => {
        setSeller(authData.defaultSeller);
    }, [authData.defaultSeller]);

    const onAdminDownloadExcel = (row) => {
        const data = {
            seller_id: row.id,
            start_date: row.start_date,
            end_date: row.end_date,
        };
        setLoading(true);
        dispatch(downloadAdminCommissionExcel(data)).then(res => {
            const link = document.createElement("a");
            link.href = res.payload;
            link.setAttribute("download", "");
            document.body.appendChild(link);
            link.click();
            link.remove();
        }).finally(() => setLoading(false));
    };

    const onAdminDownloadPDF = (row) => {
        const data = {
            seller_id: row.id,
            start_date: row.start_date,
            end_date: row.end_date,
        };
        setLoading(true);
        dispatch(downloadAdminCommissionPdf(data)).then(res => {
            const url = window.URL.createObjectURL(new Blob([res.payload]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${row.name}_${(new Date().toJSON().slice(0, 10))}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        }).finally(() => setLoading(false));
    };

    const onAdminEmail = (row) => {
        const data = {
            seller_id: row.id,
            start_date: moment(sellerCommission.sellerCommissionStartDate).format('YYYY-MM-DD'),
            end_date: moment(sellerCommission.sellerCommissionEndDate).format('YYYY-MM-DD'),
        };
        setLoading(true);
        dispatch(EmailAdminCommissionExport(data)).then(() => setLoading(false));
    };

    const onResendXero = (row) => {
        setResendingBatchId(row.batch_id);
        dispatch(resendXeroCommission({ batch_ids: [row.batch_id] })).then(() => {
            setResendingBatchId(null);
            getData();
        });
    };

    const onAdminCommissionView = (row) => {
        history.push(`/commission/detail-commission?seller=${row.id}&seller_name=${row.seller_name}&start_date=${row.start_date}&end_date=${row.end_date}`);
    };

    useEffect(() => {
        dispatch(getSellerSettings()).then(res => {
            if (!res.error) {
                dispatch(setSettings({ settings: res.payload, id: null }));
            }
        });
    }, [dispatch]);

    useEffect(() => {
        getData();
    }, [page, pageSize, month, seller]);

    const getData = () => {
        setLoading(true);
        dispatch(getCommissions({
            page,
            pageSize,
            seller_id: seller && seller.value ? seller.value : null,
            month_date: isValidDate(month) ? moment(month).format('YYYY-MM-DD') : null,
        })).then(res => {
            if (!res.error) setLoading(false);
        });
    };

    const sellerPromiseOption = (inputValue) =>
        new Promise((resolve) => {
            setTimeout(() => {
                resolve(mapSearchAutoSuggestion(sellerAutoSuggestionApi({ value: inputValue })));
            });
        });

    const onPageChange = (p) => setPage(p);
    const onPageSizeChange = (size) => {
        setPage(1);
        setPageSize(size === 'All' ? sellerCommission.sellerCommissionTableRow : size);
    };

    return (
        <Fragment>
            <Breadcrumb title="Seller Commission" data={dataMenu} />
            <Container fluid={true} className="finances-summary-page">

                {/* Filters Card */}
                <Card className="px-3 mb-3">
                    <CardBody>
                        <Row>
                            <Col md="3">
                                <FormGroup className="mb-0">
                                    <MonthPicker
                                        dateChange={(date) => {
                                            setMonth(date);
                                            setPage(1);
                                        }}
                                        defaultValue={month}
                                        disabledDate={disabledMonth}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="3">
                                <FormGroup className="mb-0">
                                    <AsyncSelect
                                        className="select2-filter"
                                        isClearable={true}
                                        defaultOptions
                                        placeholder="Search Seller"
                                        loadOptions={sellerPromiseOption}
                                        components={{ IndicatorSeparator: () => null }}
                                        value={seller}
                                        onChange={(e) => {
                                            setSeller(e);
                                            setPage(1);
                                        }}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>

                {/* Table Card */}
                <Card className="px-3">
                    <CardBody>
                        <BootstrapTable
                            headerColumns={tableColumns}
                            gridData={sellerCommission.sellerCommissionLists}
                            noAction
                            progressPending={loading}
                            paginationServer
                            paginationTotalRows={sellerCommission.sellerCommissionTableRow}
                            currentPage={page}
                            perPage={pageSize}
                            onChangePage={onPageChange}
                            onChangeRowsPerPage={onPageSizeChange}
                            size="md"
                            wrap={false}
                        />
                    </CardBody>
                </Card>

            </Container>
        </Fragment>
    );
};

export default withReducer([{ seller: sellerReducer }])(SellerCommission);
